export default "__VITE_PUBLIC_ASSET__f46522ce__"